module.exports = __webpack_public_path__ + "img/sidebar-2.9f63bef3.png";